import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import * as TanstackQuery from './integrations/tanstack-query/root-provider'
import * as Sentry from "@sentry/tanstackstart-react";

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Create a new router instance
export const getRouter = () => {
  const rqContext = TanstackQuery.getContext()

  const router = createRouter({
    routeTree,
    context: { ...rqContext },
    defaultPreload: 'intent',
    Wrap: (props: { children: React.ReactNode }) => {
      return (
        <TanstackQuery.Provider {...rqContext}>
          {props.children}
        </TanstackQuery.Provider>
      )
    },
  })

  if (!router.isServer) {
    Sentry.init({
      dsn: "https://c0ae03a0858356eb6107d4f1e5cc9b24@o4506033501569024.ingest.us.sentry.io/4511391777816576",
      sendDefaultPii: true,
      enableLogs: true,
    });
  }

  setupRouterSsrQueryIntegration({ router, queryClient: rqContext.queryClient })

  return router
}
